import { render, staticRenderFns } from "./VerificationComponent.vue?vue&type=template&id=7401a4ec&scoped=true&"
import script from "./VerificationComponent.vue?vue&type=script&lang=js&"
export * from "./VerificationComponent.vue?vue&type=script&lang=js&"
import style0 from "./VerificationComponent.vue?vue&type=style&index=0&id=7401a4ec&scoped=true&lang=scss&"
import style1 from "./VerificationComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7401a4ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VDivider,VRow})
